<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close" />
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ t("account-delete-agree-title") }}</h5>
          <p v-html="description" />
        </div>
        <ul>
          <li>
            <input id="check1" v-model="isAgree" type="checkbox">
            <label for="check1">{{ t("account-delete-agree-info") }}</label>
          </li>
        </ul>
        <div class="btnArea">
          <button :class="{ disabled : !isAgree }" @click.stop="onClickDeleteAccount">{{ t("account-my-delete") }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from "~/store/dialog/dialogStore";
import {useI18n} from "vue-i18n";
import {useToastStore} from "~/store/toast/toastStore";
import {ToastType} from "~/components/Common/Toast/model/ToastType";
import {useUserService} from "~/composables/service/useUserService";
import {removeCookie} from "~~/package/utils/CookieUtil";
import {useRouter} from "#imports";
import { convertToNextLine } from "~/utils/StringUtil";
import { CookieKeyType } from "~~/package/mapper/common/model/CookieKeyType";

const { t } = useI18n();
const { $i18n } = useNuxtApp();
const dialogStore = useDialogStore();
const toastStore = useToastStore();
const userService = useUserService();

const router = useRouter()

const isAgree = ref(false)

const description = computed(() => {
  const linkDom = `<a class="link" href="/policy?tab=2" target="_blank">${t("common-privacy-policy")}</a>`
  return convertToNextLine(t("account-delete-agree-description", {linkDom}));
})

const onClickDeleteAccount = () => {
  if(!isAgree.value) return;

  userService.deleteAccount().then((isSuccess: boolean) => {
    if(isSuccess) handlerSuccess();
    else handlerFail();
  }).catch(handlerFail);
}

const handlerSuccess = async () => {
  // SEC-1 (TSK-10568): clear server-side HttpOnly cookie + legacy JS cookie.
  await useUserService().userSignOut();
  removeCookie(CookieKeyType.ACCESS_TOKEN);
  removeCookie(CookieKeyType.OPEN_CREDIT_BANNER);
  useUserService().userLogOut();
  router.replace({ path: "/" });

  toastStore.openToast({
    toastType: ToastType.SUCCESS,
    contents: t("account-delete-success"),
  });
  dialogStore.close();

}

const handlerFail = () => {
  toastStore.openToast({
    toastType: ToastType.FAILED,
    contents: t("account-delete-fail"),
  });
}
</script>
